module.exports = __webpack_public_path__ + "static/media/pl.5bc7f5a7.svg";